// Shared placeholder card used by both MPProductGridSkeleton (grid layout) and
// ProductSliderSkeleton (slider layout) — each wraps this in whatever list element its
// layout needs (<li> for a grid, a plain child for a Slider).
export const ProductCardSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-2">
    <div className="aspect-3/4 rounded bg-neutral-200" />
    <div className="h-4 w-3/4 rounded bg-neutral-200" />
    <div className="h-3 w-1/2 rounded bg-neutral-200" />
  </div>
);
